import {
    lazy,
    Suspense,
    useMemo,
} from 'react';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

import { authState } from 'store/state';

import CardLoader from 'components/UI/CardLoader';
import useAllocationClaimData from './useAllocationClaimData';

import StyledHome from './styles';

const InfoCard = lazy(() => import('./InfoCard'));
const AllocationInfoCard = lazy(() => import('./AllocationInfoCard'));
const AllocationClaimCard = lazy(() => import('./AllocationClaimCard'));
const ConnectWalletCard = lazy(() => import('./ConnectWalletCard'));
const NoAllocationCard = lazy(() => import('./NoAllocationCard'));

const Home = () => {
    const [auth] = useRecoilState(authState);
    const { t } = useTranslation();
    const { currentAddress } = auth || {};

    const {
        data,
        isLoading,
        refetch,
    } = useAllocationClaimData(auth);

    const isAllocationClaimCardVisible = useMemo(
        () => !['NotAllocated', 'Canceled'].includes(data?.state),
        [data],
    );

    return (
        <StyledHome className="container">
            <Suspense fallback={<></>}>
                <div className="cards">
                    {!currentAddress ? (
                        <>
                            <InfoCard t={t} />
                            <ConnectWalletCard t={t} />
                        </>
                    ) : (
                        <>
                            <AllocationInfoCard t={t} />
                            {isLoading && <CardLoader />}
                            {!isLoading && (isAllocationClaimCardVisible && Object.keys(data).length
                                ? (
                                    <AllocationClaimCard
                                        t={t}
                                        claimInfo={data}
                                        refetch={refetch}
                                    />
                                )
                                : <NoAllocationCard t={t} />)}
                        </>
                    )}
                </div>
            </Suspense>
        </StyledHome>
    );
};

export default Home;
